import { observable, action, computed, NetbankingAPI, debug } from "aaa";
import { ContactsStore } from "stores/ContactsStore";
import { CardStore } from "stores/CardStore";
import { FeesStore } from "stores/FeesStore";
import { ICardStateResponse } from "types/card";
import { NetbankingAPIClient } from "network/APIClient";

export class ReissueCardStore {
    cardStore = new CardStore();
    feesStore = new FeesStore();

    @observable isLoadingReissue = false;
    response?: ICardStateResponse;

    @computed get isLoading(): boolean {
        return this.cardStore.isLoading
            || this.feesStore.isLoading
            ;
    }

    @action async load(cardId: string) {
        await Promise.all([
            this.cardStore.loadCard(cardId),
            this.feesStore.load(cardId)
        ]);
    }

    @action async reissueCard() {
        if (!this.cardStore.card) {
            return;
        }

        try {
            this.isLoadingReissue = true;
            const target = NetbankingAPI.putStates(this.cardStore.card.id, { action: "REISSUE_CARD" });
            this.response = await NetbankingAPIClient.requestType(target);
            debug.log("### reissueCard", this.response);
            this.isLoadingReissue = false;
        } catch (error) {
            this.isLoadingReissue = false;
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/reissueCard/ReissueCardStore.tsx